<template>
  <div class="loading-container">
    <svg
      cache-id="30b7efd064374a6298ac8ee55b6eec999"
      id="eMQIXw5KNUp1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1718.64 1705.77"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
    >
      <g>
        <g transform="translate(0 2.591962)">
          <path
            id="eMQIXw5KNUp4"
            d="M922.89,752.21c-10.8,21.04-25.74,39-44.83,53.94s-41.93,26.05-68.49,33.21c-26.56,7.2-55.62,10.8-87.19,10.8-27.11,0-50.38-1.64-69.74-4.97-19.36-3.32-35.44-7.31-48.15-12.05-12.75-4.69-22.3-9-28.63-12.87-6.38-3.87-10.4-5.79-12.05-5.79s-5.28,3.32-10.8,9.94c-5.55,6.65-10.52,13.03-14.94,19.13h-7.47l-2.5-165.26h8.33c4.97,14.98,11.3,29.49,19.09,43.61c7.74,14.12,16.19,27.38,25.31,39.86c9.15,12.44,18.81,23.39,29.06,32.78c10.25,9.43,20.07,16.62,29.49,21.59c9.39,4.97,21.83,9.97,37.35,14.94c15.49,4.97,30.43,7.47,44.83,7.47c40.95,0,74.16-11.19,99.62-33.64c25.46-22.41,38.21-52.69,38.21-90.9c0-15.49-2.5-29.06-7.47-40.68-5.01-11.62-11.77-21.71-20.38-30.31-8.57-8.57-18.66-15.88-30.27-21.98-11.62-6.1-24.09-11.62-37.35-16.62-13.3-4.97-24.92-9.11-34.89-12.44-9.97-3.32-19.24-6.49-27.81-9.54-8.61-3.05-17.45-6.1-26.56-9.15-9.15-3.01-20.07-7.04-32.82-12.01-14.39-5.55-28.2-13.14-41.5-22.84s-24.92-21.04-34.89-34.03c-9.94-13.03-17.99-27.42-24.06-43.18-6.1-15.8-9.15-32.5-9.15-50.22c0-29.92,5.48-55.66,16.39-77.21c10.91-21.59,25.58-39.58,44-53.98c18.42-14.39,39.66-25.03,63.76-31.96c24.06-6.92,49.4-10.4,75.96-10.4c24.92,0,46.19,2.07,63.91,6.22c17.72,4.19,32.27,8.72,43.61,13.73c11.34,4.97,19.91,9.54,25.74,13.69c5.79,4.15,9,6.22,9.54,6.22c1.64,0,5.12-3.32,10.37-9.97c5.28-6.61,10.09-13.26,14.55-19.91h9.11v153.6h-9.11c-6.65-18.27-15.25-36.38-25.74-54.37-10.52-17.99-22.73-34.07-36.53-48.19-13.85-14.08-29.61-25.58-47.33-34.42-17.72-8.88-37.35-13.3-58.95-13.3-17.17,0-33.36,2.5-48.58,7.47s-28.51,12.44-39.86,22.41c-11.34,9.97-20.22,22.3-26.56,36.96-6.38,14.67-9.54,31.41-9.54,50.22c0,29.34,8.84,52.84,26.48,70.56c17.68,17.72,40.6,31.84,68.76,42.36c11.03,4.42,21.36,8.29,31.02,11.62c9.7,3.32,19.21,6.49,28.59,9.54c9.39,3.05,18.89,6.22,28.55,9.54c9.7,3.32,19.75,6.92,30.27,10.8c37.51,13.85,66.65,33.91,87.34,60.2c20.73,26.28,31.06,59.1,31.06,98.37c0,26.56-5.4,50.38-16.19,71.42Z"
            transform="matrix(.877625 0 0 0.877624 89.77125 66.548683)"
            opacity="0"
            fill="#0b2340"
          />
          <path
            id="eMQIXw5KNUp5"
            d="M1197.69,1146.2c-6.1,16.04-14.12,30.16-24.06,42.32-9.97,12.2-21.04,22.57-33.21,31.14-12.2,8.61-24.37,15.1-36.53,19.52-21.04,7.78-44.59,12.48-70.56,14.12-26.05,1.68-51.24,2.5-75.57,2.5h-286.43v-8.33c13.81-2.19,26.99-5.79,39.43-10.76c12.44-5.01,22.57-11.93,30.31-20.77c2.74-3.32,4.97-8.17,6.65-14.55c1.64-6.34,3.17-13.69,4.54-21.98c1.41-8.29,2.35-17.01,2.93-26.17.55-9.11.82-18.11.82-26.99c0-7.74.12-18.27.43-31.53.23-13.3.51-27.81.82-43.61.27-15.76.39-31.96.39-48.54v-128.69c0-12.16-.12-24.64-.39-37.39-.31-12.71-.43-27.38-.43-44c0-9.94-.27-20.03-.82-30.27-.55-10.25-1.53-20.07-2.89-29.49-1.41-9.39-3.05-17.84-5.01-25.31-1.92-7.47-4.54-12.87-7.86-16.19-8.33-8.84-16.62-14.82-24.92-17.88-8.29-3.01-19.95-5.36-34.89-7.04v-8.29h279.82c21,0,41.07,1.25,60.2,3.72c19.09,2.5,37.47,7.08,55.19,13.73c28.24,10.52,51.47,26.56,69.74,48.15s27.42,48.97,27.42,82.18c0,36.53-11.77,66.03-35.32,88.44-23.51,22.41-54.1,37.51-91.72,45.26v3.29c19.91,2.23,39.54,7.08,58.95,14.55c19.36,7.47,36.65,17.56,51.9,30.31c15.22,12.71,27.38,27.81,36.53,45.22c9.11,17.45,13.69,37.24,13.69,59.38c0,19.95-3.05,37.94-9.15,53.98ZM1056.13,731.9c-14.12-21.59-31.68-37.08-52.73-46.51-24.88-11.07-56.72-16.58-95.48-16.58-11.62,0-22.14.55-31.53,1.64-9.43,1.13-16.62,2.5-21.59,4.15-.55,3.32-1.13,6.38-1.68,9.15-.55,2.78-.94,6.22-1.21,10.37-.31,4.15-.59,9.27-.86,15.37s-.7,14.12-1.25,24.06c-.55,19.4-.94,40.68-1.21,63.95-.31,23.23-.43,45.37-.43,66.42v79.72h46.51c12.71,0,22.96-.27,30.7-.86c49.83-2.74,87.58-16.86,113.31-42.32c25.74-25.46,38.65-56.99,38.65-94.66c0-27.65-7.08-52.3-21.2-73.89Zm45.69,324.22c-5.28-14.12-12.48-27.11-21.59-39.04-9.15-11.89-19.95-22.14-32.39-30.7-12.44-8.57-26.17-15.37-41.11-20.34-12.16-3.87-24.21-6.49-36.1-7.9-11.93-1.37-25.89-2.07-41.93-2.07h-80.54v103.77c0,15.53.12,29.77.43,42.75.27,13.03.39,24.25.39,33.64.55,21.04,1.53,38.33,2.93,51.9c1.37,13.57,5.4,24.76,12.01,33.6c5.01,6.1,12.48,11.23,22.41,15.37c9.97,4.15,24.37,6.22,43.18,6.22c16.04,0,33.48-1.1,52.3-3.32c18.81-2.19,37.08-8.02,54.8-17.41c23.27-12.16,41.23-28.36,53.98-48.58c12.71-20.18,19.09-44.43,19.09-72.64c0-16.08-2.62-31.14-7.86-45.26Z"
            transform="matrix(.882465 0 0 0.882465 110.375337 112.470407)"
            opacity="0"
            fill="#0b2340"
          />
        </g>
        <ellipse
          id="eMQIXw5KNUp6"
          rx="826.187794"
          ry="826.187794"
          transform="matrix(-.63126 0.633468-.633468-.63126 846.985219 851.16)"
          fill="none"
          stroke="#0b2340"
          stroke-width="10"
          stroke-dashoffset="5191.09"
          stroke-dasharray="5191.09"
        />
        <g clip-path="url(#eMQIXw5KNUp22)">
          <g
            id="eMQIXw5KNUp8"
            transform="matrix(-.850873 0.275029-.275029-.850873 1822.105636 1335.473213)"
          >
            <path
              d="M342.22,1513.63L308.8,1537.4l-11.66-7.52l125.04-86.7l7.71,4.96-27.19,149.73-11.66-7.53l7.65-40.35-56.48-36.36Zm75.07-54.55l-66.46,47.31l51.06,32.89l15.4-80.2Z"
              fill="#0b2340"
            />
            <path
              d="M531.26,1515.74l-36.35-15.29l4.31-10.25l85.31,35.85-4.32,10.25-36.54-15.36-49.69,118.25-12.41-5.22l49.69-118.24Z"
              fill="#0b2340"
            />
            <path
              d="M703.31,1696.81l-12.99-1.51l16.19-138.46l33.93,3.98c15.9,1.85,26.08,5.6,32.81,11.89c7.98,7.42,11.45,18.04,9.98,30.65-1.68,14.36-9.85,25.4-21.9,29.29-6.93,2.14-15.08,2.96-26.04,2.45l44.41,70.66-14.93-1.76-42.86-68.9-11.24-1.3-7.38,63Zm27.02-71.32c13.58,1.58,21.15.71,27.07-2.93c6.78-4.12,11.39-11.65,12.41-20.37c1.11-9.51-2.19-18.34-8.83-23.65-4.49-3.65-11.14-5.63-22.78-6.98l-19.97-2.31-6.33,54.08l18.42,2.17Z"
              fill="#0b2340"
            />
            <path
              d="M849.12,1566.01l13.46-.48l4.89,139.36-13.47.48-4.89-139.36Z"
              fill="#0b2340"
            />
            <path
              d="M914.94,1563.58l13.99-2.71l65.32,110.65l19.2-126.97l13.99-2.72-24.39,147.46-10.54,2.05-77.57-127.76Z"
              fill="#0b2340"
            />
            <path
              d="M1075.36,1525.52l68.58-27.26l4.11,10.35-56.24,22.37l18.47,46.45l50.25-20l4.12,10.35-50.26,19.97l20.71,52.09l58.42-23.24l4.11,10.34-70.75,28.14-51.52-129.55Z"
              fill="#0b2340"
            />
            <path
              d="M1284.24,1581.05l-11.04,6.98-74.48-117.77l28.87-18.25c13.53-8.55,23.79-12.04,32.98-11.4c10.87.76,20.25,6.84,27.02,17.55c7.72,12.21,8.31,25.92,1.4,36.53-4.05,6.02-9.87,11.79-18.69,18.29l78.94,26.97-12.7,8.01-76.62-26.59-9.56,6.06l33.89,53.61Zm-23.86-72.42c11.54-7.31,16.88-12.75,19.2-19.29c2.67-7.48,1.52-16.22-3.17-23.62-5.11-8.1-13.22-12.89-21.73-12.83-5.79-.03-12.19,2.64-22.09,8.89l-16.99,10.76l29.1,46.01l15.67-9.9Z"
              fill="#0b2340"
            />
            <path
              d="M1325.42,1365.24l18.81,50.68-7.8,6.8-22.19-47.74l11.18-9.73Z"
              fill="#0b2340"
            />
            <path
              d="M1456.77,1418.03c11.88-2.37,24.32-10.44,35.08-22.83c13.7-15.77,14.41-31.18,2.02-41.95-5.9-5.12-13.13-7.52-20.11-6.33-6.71,1.16-9.65,2.48-26.61,11.31-26.57,13.91-40.53,14.19-54.99,1.66-15.78-13.71-15.78-33.36.35-51.95c8.96-10.32,18.74-16.83,31.08-20.62l4.04,10.24c-11.22,3.71-19.03,8.82-26.59,17.52-11.14,12.83-11.6,25.88-1.28,34.85c5.31,4.6,12.24,6.74,18.95,5.59c6.44-.87,11.29-2.89,23.83-9.58c16.4-8.77,24.22-11.82,33.44-12.62c8.4-.72,17.48,2.51,25.15,9.18c18.88,16.37,18.32,37.87-1.78,61.03-11.78,13.57-25.27,22.55-38.5,25.29l-4.08-10.79Z"
              fill="#0b2340"
            />
            <path
              d="M1494.51,1162.35l30.87-67.05l10.11,4.65-25.32,54.99l45.4,20.92l22.62-49.15l10.11,4.68-22.62,49.11l50.9,23.46l26.3-57.12l10.11,4.65-31.85,69.18-126.64-58.32Z"
              fill="#0b2340"
            />
            <path
              d="M1546.29,1038.3l7.6-32.92c5.8-25.11,14.89-41.04,29.15-51.58c15.24-11.31,35.03-14.56,56.53-9.58c21.49,4.96,37.86,16.54,46.59,33.4c8.19,15.73,9.38,34.03,3.58,59.14l-7.6,32.92-135.84-31.38Zm133.04-5.92c4.7-20.38,3.62-35.64-3.53-48.14-7.57-13.16-21.28-22.34-39.36-26.5-18.07-4.19-34.42-1.95-47.01,6.57-11.88,8.07-19.56,21.33-24.27,41.68l-5.01,21.69l114.15,26.37l5.01-21.68Z"
              fill="#0b2340"
            />
            <path
              d="M1645.53,800.22l-.44-53.54l10.16-.07c15.04-.13,29.52,2.68,37.95,7.31c16.1,9.03,25.24,27.91,25.44,52.72.19,22.85-6.5,40.08-20.46,53.29-12.98,12.44-29.74,18.62-50.25,18.8-43.17.34-72.31-28.12-72.66-71.1-.17-19.53,4.96-36.97,15.01-50.52l9.23,5.59c-8.89,12.19-13.26,27.07-13.12,43.86.29,35.36,24.51,58.6,61.03,58.29c16.81-.14,30.83-4.94,41.89-14.2c12.41-10.66,18.35-24.77,18.19-44.12-.25-30.66-15.42-46.35-44.53-46.12l-7.43.07.32,39.65-10.35.1Z"
              fill="#0b2340"
            />
            <path
              d="M1566.82,690.42l-16.13-71.99l10.86-2.44l13.22,59.05l48.77-10.92-11.81-52.76l10.85-2.44l11.82,52.78l54.67-12.24-13.74-61.34l10.86-2.44l16.64,74.29-136.01,30.45Z"
              fill="#0b2340"
            />
          </g>
          <clipPath id="eMQIXw5KNUp22">
            <path
              d="M31.279688,1725.932941C1196.54832,571.479862,1905.092409,460.196627,1900.348502,458.468653s-124.770036,1285.921576-122.178075,1283.329614q2.591961-2.591962-1746.890739-15.865326Z"
              transform="matrix(.997085 0 0 1.002928 2.591685-2.508251)"
              stroke-width="3.43728"
            />
          </clipPath>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  setup() {},
  mounted() {
    !(function (t, e) {
      "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = e())
        : "function" == typeof __SVGATOR_DEFINE__ && __SVGATOR_DEFINE__.amd
        ? __SVGATOR_DEFINE__(e)
        : (((t =
            "undefined" != typeof globalThis
              ? globalThis
              : t || self).__SVGATOR_PLAYER__ = t.__SVGATOR_PLAYER__ || {}),
          (t.__SVGATOR_PLAYER__["91c80d77"] = e()));
    })(this, function () {
      "use strict";
      function t(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function e(e) {
        for (var n = 1; n < arguments.length; n++) {
          var r = null != arguments[n] ? arguments[n] : {};
          n % 2
            ? t(Object(r), !0).forEach(function (t) {
                u(e, t, r[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
            : t(Object(r)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(r, t)
                );
              });
        }
        return e;
      }
      function n(t) {
        return (n =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            "value" in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r);
        }
      }
      function o(t, e, n) {
        return e && i(t.prototype, e), n && i(t, n), t;
      }
      function u(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function a(t) {
        return (a = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function s(t, e) {
        return (s =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          })(t, e);
      }
      function l() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            ),
            !0
          );
        } catch (t) {
          return !1;
        }
      }
      function f(t, e, n) {
        return (f = l()
          ? Reflect.construct
          : function (t, e, n) {
              var r = [null];
              r.push.apply(r, e);
              var i = new (Function.bind.apply(t, r))();
              return n && s(i, n.prototype), i;
            }).apply(null, arguments);
      }
      function c(t, e) {
        if (e && ("object" == typeof e || "function" == typeof e)) return e;
        if (void 0 !== e)
          throw new TypeError(
            "Derived constructors may only return object or undefined"
          );
        return (function (t) {
          if (void 0 === t)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return t;
        })(t);
      }
      function h(t, e, n) {
        return (h =
          "undefined" != typeof Reflect && Reflect.get
            ? Reflect.get
            : function (t, e, n) {
                var r = (function (t, e) {
                  for (
                    ;
                    !Object.prototype.hasOwnProperty.call(t, e) &&
                    null !== (t = a(t));

                  );
                  return t;
                })(t, e);
                if (r) {
                  var i = Object.getOwnPropertyDescriptor(r, e);
                  return i.get ? i.get.call(n) : i.value;
                }
              })(t, e, n || t);
      }
      function v(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return d(t);
          })(t) ||
          (function (t) {
            if (
              ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
              null != t["@@iterator"]
            )
              return Array.from(t);
          })(t) ||
          (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return d(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === n && t.constructor && (n = t.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(t);
            if (
              "Arguments" === n ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
            )
              return d(t, e);
          })(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function d(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
      }
      Number.isInteger ||
        (Number.isInteger = function (t) {
          return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
        }),
        Number.EPSILON || (Number.EPSILON = 2220446049250313e-31);
      var y = g(Math.pow(10, -6));
      function g(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6;
        if (Number.isInteger(t)) return t;
        var n = Math.pow(10, e);
        return Math.round((+t + Number.EPSILON) * n) / n;
      }
      function p(t, e) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : y;
        return Math.abs(t - e) < n;
      }
      var m = Math.PI / 180;
      function b(t) {
        return t;
      }
      function w(t, e, n) {
        var r = 1 - n;
        return 3 * n * r * (t * r + e * n) + n * n * n;
      }
      function k() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
          r =
            arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
        return t < 0 || t > 1 || n < 0 || n > 1
          ? null
          : p(t, e) && p(n, r)
          ? b
          : function (i) {
              if (i <= 0)
                return t > 0 ? (i * e) / t : 0 === e && n > 0 ? (i * r) / n : 0;
              if (i >= 1)
                return n < 1
                  ? 1 + ((i - 1) * (r - 1)) / (n - 1)
                  : 1 === n && t < 1
                  ? 1 + ((i - 1) * (e - 1)) / (t - 1)
                  : 1;
              for (var o, u = 0, a = 1; u < a; ) {
                var s = w(t, n, (o = (u + a) / 2));
                if (p(i, s)) break;
                s < i ? (u = o) : (a = o);
              }
              return w(e, r, o);
            };
      }
      function _() {
        return 1;
      }
      function A(t) {
        return 1 === t ? 1 : 0;
      }
      function x() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
          e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (1 === t) {
          if (0 === e) return A;
          if (1 === e) return _;
        }
        var n = 1 / t;
        return function (t) {
          return t >= 1 ? 1 : (t += e * n) - (t % n);
        };
      }
      var O = Math.sin,
        S = Math.cos,
        E = Math.acos,
        P = Math.asin,
        j = Math.tan,
        M = Math.atan2,
        B = Math.PI / 180,
        I = 180 / Math.PI,
        T = Math.sqrt,
        R = (function () {
          function t() {
            var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : 1,
              n =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0,
              i =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : 0,
              o =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : 1,
              u =
                arguments.length > 4 && void 0 !== arguments[4]
                  ? arguments[4]
                  : 0,
              a =
                arguments.length > 5 && void 0 !== arguments[5]
                  ? arguments[5]
                  : 0;
            r(this, t),
              (this.m = [e, n, i, o, u, a]),
              (this.i = null),
              (this.w = null),
              (this.s = null);
          }
          return (
            o(
              t,
              [
                {
                  key: "determinant",
                  get: function () {
                    var t = this.m;
                    return t[0] * t[3] - t[1] * t[2];
                  },
                },
                {
                  key: "isIdentity",
                  get: function () {
                    if (null === this.i) {
                      var t = this.m;
                      this.i =
                        1 === t[0] &&
                        0 === t[1] &&
                        0 === t[2] &&
                        1 === t[3] &&
                        0 === t[4] &&
                        0 === t[5];
                    }
                    return this.i;
                  },
                },
                {
                  key: "point",
                  value: function (t, e) {
                    var n = this.m;
                    return {
                      x: n[0] * t + n[2] * e + n[4],
                      y: n[1] * t + n[3] * e + n[5],
                    };
                  },
                },
                {
                  key: "translateSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0;
                    if (!t && !e) return this;
                    var n = this.m;
                    return (
                      (n[4] += n[0] * t + n[2] * e),
                      (n[5] += n[1] * t + n[3] * e),
                      (this.w = this.s = this.i = null),
                      this
                    );
                  },
                },
                {
                  key: "rotateSelf",
                  value: function () {
                    var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0;
                    if ((t %= 360)) {
                      var e = O((t *= B)),
                        n = S(t),
                        r = this.m,
                        i = r[0],
                        o = r[1];
                      (r[0] = i * n + r[2] * e),
                        (r[1] = o * n + r[3] * e),
                        (r[2] = r[2] * n - i * e),
                        (r[3] = r[3] * n - o * e),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "scaleSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 1,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 1;
                    if (1 !== t || 1 !== e) {
                      var n = this.m;
                      (n[0] *= t),
                        (n[1] *= t),
                        (n[2] *= e),
                        (n[3] *= e),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "skewSelf",
                  value: function (t, e) {
                    if (((e %= 360), (t %= 360) || e)) {
                      var n = this.m,
                        r = n[0],
                        i = n[1],
                        o = n[2],
                        u = n[3];
                      t && ((t = j(t * B)), (n[2] += r * t), (n[3] += i * t)),
                        e && ((e = j(e * B)), (n[0] += o * e), (n[1] += u * e)),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "resetSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 1,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : 0,
                      r =
                        arguments.length > 3 && void 0 !== arguments[3]
                          ? arguments[3]
                          : 1,
                      i =
                        arguments.length > 4 && void 0 !== arguments[4]
                          ? arguments[4]
                          : 0,
                      o =
                        arguments.length > 5 && void 0 !== arguments[5]
                          ? arguments[5]
                          : 0,
                      u = this.m;
                    return (
                      (u[0] = t),
                      (u[1] = e),
                      (u[2] = n),
                      (u[3] = r),
                      (u[4] = i),
                      (u[5] = o),
                      (this.w = this.s = this.i = null),
                      this
                    );
                  },
                },
                {
                  key: "recomposeSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : null,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : null,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : null,
                      r =
                        arguments.length > 3 && void 0 !== arguments[3]
                          ? arguments[3]
                          : null,
                      i =
                        arguments.length > 4 && void 0 !== arguments[4]
                          ? arguments[4]
                          : null;
                    return (
                      this.isIdentity || this.resetSelf(),
                      t && (t.x || t.y) && this.translateSelf(t.x, t.y),
                      e && this.rotateSelf(e),
                      n &&
                        (n.x && this.skewSelf(n.x, 0),
                        n.y && this.skewSelf(0, n.y)),
                      !r ||
                        (1 === r.x && 1 === r.y) ||
                        this.scaleSelf(r.x, r.y),
                      i && (i.x || i.y) && this.translateSelf(i.x, i.y),
                      this
                    );
                  },
                },
                {
                  key: "decompose",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0,
                      n = this.m,
                      r = n[0] * n[0] + n[1] * n[1],
                      i = [
                        [n[0], n[1]],
                        [n[2], n[3]],
                      ],
                      o = T(r);
                    if (0 === o)
                      return {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: 0, y: 0 },
                        skew: { x: 0, y: 0 },
                        rotate: 0,
                      };
                    (i[0][0] /= o), (i[0][1] /= o);
                    var u = n[0] * n[3] - n[1] * n[2] < 0;
                    u && (o = -o);
                    var a = i[0][0] * i[1][0] + i[0][1] * i[1][1];
                    (i[1][0] -= i[0][0] * a), (i[1][1] -= i[0][1] * a);
                    var s = T(i[1][0] * i[1][0] + i[1][1] * i[1][1]);
                    if (0 === s)
                      return {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: g(o), y: 0 },
                        skew: { x: 0, y: 0 },
                        rotate: 0,
                      };
                    (i[1][0] /= s), (i[1][1] /= s), (a /= s);
                    var l = 0;
                    return (
                      i[1][1] < 0
                        ? ((l = E(i[1][1]) * I), i[0][1] < 0 && (l = 360 - l))
                        : (l = P(i[0][1]) * I),
                      u && (l = -l),
                      (a = M(a, T(i[0][0] * i[0][0] + i[0][1] * i[0][1])) * I),
                      u && (a = -a),
                      {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: g(o), y: g(s) },
                        skew: { x: g(a), y: 0 },
                        rotate: g(l),
                      }
                    );
                  },
                },
                {
                  key: "clone",
                  value: function () {
                    var t = this.m;
                    return new this.constructor(
                      t[0],
                      t[1],
                      t[2],
                      t[3],
                      t[4],
                      t[5]
                    );
                  },
                },
                {
                  key: "toString",
                  value: function () {
                    var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : " ";
                    if (null === this.s) {
                      var e = this.m.map(function (t) {
                        return g(t);
                      });
                      1 === e[0] && 0 === e[1] && 0 === e[2] && 1 === e[3]
                        ? (this.s = "translate(" + e[4] + t + e[5] + ")")
                        : (this.s = "matrix(" + e.join(t) + ")");
                    }
                    return this.s;
                  },
                },
              ],
              [
                {
                  key: "create",
                  value: function (t) {
                    return t
                      ? Array.isArray(t)
                        ? f(this, v(t))
                        : t instanceof this
                        ? t.clone()
                        : new this().recomposeSelf(
                            t.origin,
                            t.rotate,
                            t.skew,
                            t.scale,
                            t.translate
                          )
                      : new this();
                  },
                },
              ]
            ),
            t
          );
        })();
      function N(t, e, n) {
        return t >= 0.5 ? n : e;
      }
      function F(t, e, n) {
        return 0 === t || e === n ? e : t * (n - e) + e;
      }
      function C(t, e, n) {
        var r = F(t, e, n);
        return r <= 0 ? 0 : r;
      }
      function D(t, e, n) {
        var r = F(t, e, n);
        return r <= 0 ? 0 : r >= 1 ? 1 : r;
      }
      function L(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : { x: F(t, e.x, n.x), y: F(t, e.y, n.y) };
      }
      function V(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : { x: C(t, e.x, n.x), y: C(t, e.y, n.y) };
      }
      function q(t, e, n) {
        var r = (function (t, e, n) {
          return Math.round(F(t, e, n));
        })(t, e, n);
        return r <= 0 ? 0 : r >= 255 ? 255 : r;
      }
      function G(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : {
              r: q(t, e.r, n.r),
              g: q(t, e.g, n.g),
              b: q(t, e.b, n.b),
              a: F(t, null == e.a ? 1 : e.a, null == n.a ? 1 : n.a),
            };
      }
      function z(t, e, n) {
        var r = e.length;
        if (r !== n.length) return N(t, e, n);
        for (var i = new Array(r), o = 0; o < r; o++) i[o] = F(t, e[o], n[o]);
        return i;
      }
      function Y(t, e) {
        for (var n = [], r = 0; r < t; r++) n.push(e);
        return n;
      }
      function U(t, e) {
        if (--e <= 0) return t;
        var n = (t = Object.assign([], t)).length;
        do {
          for (var r = 0; r < n; r++) t.push(t[r]);
        } while (--e > 0);
        return t;
      }
      var W,
        $ = (function () {
          function t(e) {
            r(this, t), (this.list = e), (this.length = e.length);
          }
          return (
            o(t, [
              {
                key: "setAttribute",
                value: function (t, e) {
                  for (var n = this.list, r = 0; r < this.length; r++)
                    n[r].setAttribute(t, e);
                },
              },
              {
                key: "removeAttribute",
                value: function (t) {
                  for (var e = this.list, n = 0; n < this.length; n++)
                    e[n].removeAttribute(t);
                },
              },
              {
                key: "style",
                value: function (t, e) {
                  for (var n = this.list, r = 0; r < this.length; r++)
                    n[r].style[t] = e;
                },
              },
            ]),
            t
          );
        })(),
        H = /-./g,
        Q = function (t, e) {
          return e.toUpperCase();
        };
      function X(t) {
        return "function" == typeof t ? t : N;
      }
      function J(t) {
        return t
          ? "function" == typeof t
            ? t
            : Array.isArray(t)
            ? (function (t) {
                var e =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : b;
                if (!Array.isArray(t)) return e;
                switch (t.length) {
                  case 1:
                    return x(t[0]) || e;
                  case 2:
                    return x(t[0], t[1]) || e;
                  case 4:
                    return k(t[0], t[1], t[2], t[3]) || e;
                }
                return e;
              })(t, null)
            : (function (t, e) {
                var n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : b;
                switch (t) {
                  case "linear":
                    return b;
                  case "steps":
                    return x(e.steps || 1, e.jump || 0) || n;
                  case "bezier":
                  case "cubic-bezier":
                    return k(e.x1 || 0, e.y1 || 0, e.x2 || 0, e.y2 || 0) || n;
                }
                return n;
              })(t.type, t.value, null)
          : null;
      }
      function K(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          i = e.length - 1;
        if (t <= e[0].t) return r ? [0, 0, e[0].v] : e[0].v;
        if (t >= e[i].t) return r ? [i, 1, e[i].v] : e[i].v;
        var o,
          u = e[0],
          a = null;
        for (o = 1; o <= i; o++) {
          if (!(t > e[o].t)) {
            a = e[o];
            break;
          }
          u = e[o];
        }
        return null == a
          ? r
            ? [i, 1, e[i].v]
            : e[i].v
          : u.t === a.t
          ? r
            ? [o, 1, a.v]
            : a.v
          : ((t = (t - u.t) / (a.t - u.t)),
            u.e && (t = u.e(t)),
            r ? [o, t, n(t, u.v, a.v)] : n(t, u.v, a.v));
      }
      function Z(t, e) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        return t && t.length
          ? "function" != typeof e
            ? null
            : ("function" != typeof n && (n = null),
              function (r) {
                var i = K(r, t, e);
                return null != i && n && (i = n(i)), i;
              })
          : null;
      }
      function tt(t, e) {
        return t.t - e.t;
      }
      function et(t, e, r, i, o) {
        var u,
          a = "@" === r[0],
          s = "#" === r[0],
          l = W[r],
          f = N;
        switch (
          (a
            ? ((u = r.substr(1)), (r = u.replace(H, Q)))
            : s && (r = r.substr(1)),
          n(l))
        ) {
          case "function":
            if (((f = l(i, o, K, J, r, a, e, t)), s)) return f;
            break;
          case "string":
            f = Z(i, X(l));
            break;
          case "object":
            if ((f = Z(i, X(l.i), l.f)) && "function" == typeof l.u)
              return l.u(e, f, r, a, t);
        }
        return f
          ? (function (t, e, n) {
              if (
                arguments.length > 3 &&
                void 0 !== arguments[3] &&
                arguments[3]
              )
                return t instanceof $
                  ? function (r) {
                      return t.style(e, n(r));
                    }
                  : function (r) {
                      return (t.style[e] = n(r));
                    };
              if (Array.isArray(e)) {
                var r = e.length;
                return function (i) {
                  var o = n(i);
                  if (null == o)
                    for (var u = 0; u < r; u++) t[u].removeAttribute(e);
                  else for (var a = 0; a < r; a++) t[a].setAttribute(e, o);
                };
              }
              return function (r) {
                var i = n(r);
                null == i ? t.removeAttribute(e) : t.setAttribute(e, i);
              };
            })(e, r, f, a)
          : null;
      }
      function nt(t, e, r, i) {
        if (!i || "object" !== n(i)) return null;
        var o = null,
          u = null;
        return (
          Array.isArray(i)
            ? (u = (function (t) {
                if (!t || !t.length) return null;
                for (var e = 0; e < t.length; e++)
                  t[e].e && (t[e].e = J(t[e].e));
                return t.sort(tt);
              })(i))
            : ((u = i.keys), (o = i.data || null)),
          u ? et(t, e, r, u, o) : null
        );
      }
      function rt(t, e, n) {
        if (!n) return null;
        var r = [];
        for (var i in n)
          if (n.hasOwnProperty(i)) {
            var o = nt(t, e, i, n[i]);
            o && r.push(o);
          }
        return r.length ? r : null;
      }
      function it(t, e) {
        if (!e.settings.duration || e.settings.duration < 0) return null;
        var n,
          r,
          i,
          o,
          u,
          a = (function (t, e) {
            if (!e) return null;
            var n = [];
            if (Array.isArray(e))
              for (var r = e.length, i = 0; i < r; i++) {
                var o = e[i];
                if (2 === o.length) {
                  var u = null;
                  if ("string" == typeof o[0]) u = t.getElementById(o[0]);
                  else if (Array.isArray(o[0])) {
                    u = [];
                    for (var a = 0; a < o[0].length; a++)
                      if ("string" == typeof o[0][a]) {
                        var s = t.getElementById(o[0][a]);
                        s && u.push(s);
                      }
                    u = u.length ? (1 === u.length ? u[0] : new $(u)) : null;
                  }
                  if (u) {
                    var l = rt(t, u, o[1]);
                    l && (n = n.concat(l));
                  }
                }
              }
            else
              for (var f in e)
                if (e.hasOwnProperty(f)) {
                  var c = t.getElementById(f);
                  if (c) {
                    var h = rt(t, c, e[f]);
                    h && (n = n.concat(h));
                  }
                }
            return n.length ? n : null;
          })(t, e.elements);
        return a
          ? ((n = a),
            (r = e.settings),
            (i = r.duration),
            (o = n.length),
            (u = null),
            function (t, e) {
              var a = r.iterations || 1 / 0,
                s = (r.alternate && a % 2 == 0) ^ (r.direction > 0) ? i : 0,
                l = t % i,
                f = 1 + (t - l) / i;
              (e *= r.direction), r.alternate && f % 2 == 0 && (e = -e);
              var c = !1;
              if (f > a)
                (l = s),
                  (c = !0),
                  -1 === r.fill && (l = r.direction > 0 ? 0 : i);
              else if ((e < 0 && (l = i - l), l === u)) return !1;
              u = l;
              for (var h = 0; h < o; h++) n[h](l);
              return c;
            })
          : null;
      }
      function ot(t, e) {
        if (((W = e), !t || !t.root || !Array.isArray(t.animations)))
          return null;
        var n = (function (t) {
          for (
            var e = document.getElementsByTagName("svg"), n = 0;
            n < e.length;
            n++
          )
            if (e[n].id === t.root && !e[n].svgatorAnimation)
              return (e[n].svgatorAnimation = !0), e[n];
          return null;
        })(t);
        if (!n) return null;
        var r = t.animations
          .map(function (t) {
            return it(n, t);
          })
          .filter(function (t) {
            return !!t;
          });
        return r.length
          ? {
              svg: n,
              animations: r,
              animationSettings: t.animationSettings,
              options: t.options || void 0,
            }
          : null;
      }
      function ut(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : null,
          n =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : Number,
          r =
            arguments.length > 3 && void 0 !== arguments[3]
              ? arguments[3]
              : "undefined" != typeof BigInt && BigInt,
          i = "0x" + (t.replace(/[^0-9a-fA-F]+/g, "") || 27);
        return e && r && n.isSafeInteger && !n.isSafeInteger(+i)
          ? (n(r(i)) % e) + e
          : +i;
      }
      function at(t, e, n) {
        return !t || !n || e > t.length
          ? t
          : t.substring(0, e) + at(t.substring(e + 1), n, n);
      }
      function st(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 27;
        return !t || t % e ? t % e : [0, 1].includes(e) ? e : st(t / e, e);
      }
      function lt(t, e, n) {
        if (t && t.length) {
          var r = ut(n),
            i = st(r) + 5,
            o = at(t, st(r, 5), i);
          return (
            (o = o.replace(/\x7c$/g, "==").replace(/\x2f$/g, "=")),
            (o = (function (t, e, n) {
              var r = +("0x" + t.substring(0, 4));
              t = t.substring(4);
              for (
                var i = (ut(e, r) % r) + (n % 27), o = [], u = 0;
                u < t.length;
                u += 2
              )
                if ("|" !== t[u]) {
                  var a = +("0x" + t[u] + t[u + 1]) - i;
                  o.push(a);
                } else {
                  var s = +("0x" + t.substring(u + 1, u + 1 + 4)) - i;
                  (u += 3), o.push(s);
                }
              return String.fromCharCode.apply(String, o);
            })((o = (o = atob(o)).replace(/[\x41-\x5A]/g, "")), e, r)),
            (o = JSON.parse(o))
          );
        }
      }
      var ft = [
          { key: "alternate", def: !1 },
          { key: "fill", def: 1 },
          { key: "iterations", def: 0 },
          { key: "direction", def: 1 },
          { key: "speed", def: 1 },
          { key: "fps", def: 100 },
        ],
        ct = (function () {
          function t(e, n) {
            var i = this,
              o =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : null;
            r(this, t),
              (this._id = 0),
              (this._running = !1),
              (this._rollingBack = !1),
              (this._animations = e),
              (this._settings = n),
              (!o || o < "2022-05-02") && delete this._settings.speed,
              ft.forEach(function (t) {
                i._settings[t.key] = i._settings[t.key] || t.def;
              }),
              (this.duration = n.duration),
              (this.offset = n.offset || 0),
              (this.rollbackStartOffset = 0);
          }
          return (
            o(
              t,
              [
                {
                  key: "alternate",
                  get: function () {
                    return this._settings.alternate;
                  },
                },
                {
                  key: "fill",
                  get: function () {
                    return this._settings.fill;
                  },
                },
                {
                  key: "iterations",
                  get: function () {
                    return this._settings.iterations;
                  },
                },
                {
                  key: "direction",
                  get: function () {
                    return this._settings.direction;
                  },
                },
                {
                  key: "speed",
                  get: function () {
                    return this._settings.speed;
                  },
                },
                {
                  key: "fps",
                  get: function () {
                    return this._settings.fps;
                  },
                },
                {
                  key: "maxFiniteDuration",
                  get: function () {
                    return this.iterations > 0
                      ? this.iterations * this.duration
                      : this.duration;
                  },
                },
                {
                  key: "_apply",
                  value: function (t) {
                    for (
                      var e =
                          arguments.length > 1 && void 0 !== arguments[1]
                            ? arguments[1]
                            : {},
                        n = this._animations,
                        r = n.length,
                        i = 0,
                        o = 0;
                      o < r;
                      o++
                    )
                      e[o] ? i++ : ((e[o] = n[o](t, 1)), e[o] && i++);
                    return i;
                  },
                },
                {
                  key: "_rollback",
                  value: function (t) {
                    var e = this,
                      n = 1 / 0,
                      r = null;
                    (this.rollbackStartOffset = t),
                      (this._rollingBack = !0),
                      (this._running = !0);
                    this._id = window.requestAnimationFrame(function i(o) {
                      if (e._rollingBack) {
                        null == r && (r = o);
                        var u = Math.round(t - (o - r) * e.speed);
                        if (u > e.duration && n !== 1 / 0) {
                          var a = !!e.alternate && (u / e.duration) % 2 > 1,
                            s = u % e.duration;
                          u = (s += a ? e.duration : 0) || e.duration;
                        }
                        var l = (e.fps ? 1e3 / e.fps : 0) * e.speed,
                          f = Math.max(0, u);
                        f <= n - l && ((e.offset = f), (n = f), e._apply(f));
                        var c =
                          e.iterations > 0 &&
                          -1 === e.fill &&
                          u >= e.maxFiniteDuration;
                        (u <= 0 || e.offset < u || c) && e.stop(),
                          (e._id = window.requestAnimationFrame(i));
                      }
                    });
                  },
                },
                {
                  key: "_start",
                  value: function () {
                    var t = this,
                      e =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      n = -1 / 0,
                      r = null,
                      i = {};
                    this._running = !0;
                    var o = function o(u) {
                      null == r && (r = u);
                      var a = Math.round((u - r) * t.speed + e),
                        s = (t.fps ? 1e3 / t.fps : 0) * t.speed;
                      if (
                        a >= n + s &&
                        !t._rollingBack &&
                        ((t.offset = a),
                        (n = a),
                        t._apply(a, i) === t._animations.length)
                      )
                        return void t.pause(!0);
                      t._id = window.requestAnimationFrame(o);
                    };
                    this._id = window.requestAnimationFrame(o);
                  },
                },
                {
                  key: "_pause",
                  value: function () {
                    this._id && window.cancelAnimationFrame(this._id),
                      (this._running = !1);
                  },
                },
                {
                  key: "play",
                  value: function () {
                    if (!this._running)
                      return this._rollingBack
                        ? this._rollback(this.offset)
                        : this._start(this.offset);
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    this._pause(),
                      (this.offset = 0),
                      (this.rollbackStartOffset = 0),
                      (this._rollingBack = !1),
                      this._apply(0);
                  },
                },
                {
                  key: "reachedToEnd",
                  value: function () {
                    return (
                      this.iterations > 0 &&
                      this.offset >= this.iterations * this.duration
                    );
                  },
                },
                {
                  key: "restart",
                  value: function () {
                    var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0];
                    this.stop(t), this.play(t);
                  },
                },
                {
                  key: "pause",
                  value: function () {
                    this._pause();
                  },
                },
                {
                  key: "reverse",
                  value: function () {
                    this.direction = -this.direction;
                  },
                },
              ],
              [
                {
                  key: "build",
                  value: function (t, e) {
                    delete t.animationSettings,
                      (t.options = lt(t.options, t.root, "91c80d77")),
                      t.animations.map(function (e) {
                        (e.settings = lt(e.s, t.root, "91c80d77")),
                          delete e.s,
                          t.animationSettings ||
                            (t.animationSettings = e.settings);
                      });
                    var n = t.version;
                    if (!(t = ot(t, e))) return null;
                    var r = t.options || {},
                      i = new this(t.animations, t.animationSettings, n);
                    return { el: t.svg, options: r, player: i };
                  },
                },
                {
                  key: "push",
                  value: function (t) {
                    return this.build(t);
                  },
                },
                {
                  key: "init",
                  value: function () {
                    var t = this,
                      e =
                        window.__SVGATOR_PLAYER__ &&
                        window.__SVGATOR_PLAYER__["91c80d77"];
                    Array.isArray(e) &&
                      e.splice(0).forEach(function (e) {
                        return t.build(e);
                      });
                  },
                },
              ]
            ),
            t
          );
        })();
      !(function () {
        for (
          var t = 0, e = ["ms", "moz", "webkit", "o"], n = 0;
          n < e.length && !window.requestAnimationFrame;
          ++n
        )
          (window.requestAnimationFrame =
            window[e[n] + "RequestAnimationFrame"]),
            (window.cancelAnimationFrame =
              window[e[n] + "CancelAnimationFrame"] ||
              window[e[n] + "CancelRequestAnimationFrame"]);
        window.requestAnimationFrame ||
          ((window.requestAnimationFrame = function (e) {
            var n = Date.now(),
              r = Math.max(0, 16 - (n - t)),
              i = window.setTimeout(function () {
                e(n + r);
              }, r);
            return (t = n + r), i;
          }),
          (window.cancelAnimationFrame = window.clearTimeout));
      })();
      var ht = (function () {
        function t(e, n, i) {
          r(this, t);
          var o = (function (t) {
            var e,
              n,
              r,
              i =
                t &&
                1 ===
                  (null === (e = t.ownerDocument) ||
                  void 0 === e ||
                  null === (n = e.childNodes) ||
                  void 0 === n
                    ? void 0
                    : n.length) &&
                window.parent !== window,
              o = { el: t, window: window };
            if (!i) return o;
            try {
              r = window.parent.document;
            } catch (t) {
              return o;
            }
            return (
              (o.window = window.parent),
              (o.el =
                Array.from(r.querySelectorAll("iframe,object")).filter(
                  function (t) {
                    return t.contentWindow === window;
                  }
                )[0] || o.el),
              o
            );
          })(e);
          (n = Math.max(1, n || 1)),
            (n = Math.min(n, 100)),
            (this.el = o.el),
            (this._handlers = []),
            (this.onThresholdChange = i && i.call ? i : function () {}),
            (this.thresholdPercent = n || 1),
            (this.currentVisibility = null),
            (this.visibilityCalculator = (function (t, e) {
              var n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : n,
                r = !1,
                i = null,
                o = function () {
                  for (
                    var o = 0,
                      u = n.innerHeight,
                      a = 0,
                      s = n.innerWidth,
                      l = t.parentNode;
                    l instanceof Element;

                  ) {
                    var f = n.getComputedStyle(l);
                    if (
                      "visible" !== f.overflowY ||
                      "visible" !== f.overflowX
                    ) {
                      var c = l.getBoundingClientRect();
                      "visible" !== f.overflowY &&
                        ((o = Math.max(o, c.top)), (u = Math.min(u, c.bottom))),
                        "visible" !== f.overflowX &&
                          ((a = Math.max(a, c.left)),
                          (s = Math.min(s, c.right)));
                    }
                    if (l === l.parentNode) break;
                    l = l.parentNode;
                  }
                  r = !1;
                  var h = t.getBoundingClientRect(),
                    v = Math.min(h.height, Math.max(0, o - h.top)),
                    d = Math.min(h.height, Math.max(0, h.bottom - u)),
                    y = Math.min(h.width, Math.max(0, a - h.left)),
                    g = Math.min(h.width, Math.max(0, h.right - s)),
                    p = (h.height - v - d) / h.height,
                    m = (h.width - y - g) / h.width,
                    b = Math.round(p * m * 100);
                  (null !== i && i === b) || ((i = b), e(b));
                };
              return function (t) {
                r && clearTimeout(r),
                  (r = setTimeout(function () {
                    return o();
                  }, 100));
              };
            })(this.el, this.onVisibilityUpdate.bind(this), o.window)),
            this.bindScrollWatchers(),
            this.visibilityCalculator();
        }
        return (
          o(t, [
            {
              key: "bindScrollWatchers",
              value: function () {
                for (
                  var t = this.el.parentNode;
                  t &&
                  (this._handlers.push({
                    element: t,
                    event: "scroll",
                    handler: this.visibilityCalculator,
                  }),
                  t.addEventListener("scroll", this.visibilityCalculator),
                  t !== t.parentNode && t !== document);

                )
                  t = t.parentNode;
              },
            },
            {
              key: "onVisibilityUpdate",
              value: function (t) {
                var e = this.currentVisibility >= this.thresholdPercent,
                  n = t >= this.thresholdPercent;
                if (null === this.currentVisibility || e !== n)
                  return (
                    (this.currentVisibility = t), void this.onThresholdChange(n)
                  );
                this.currentVisibility = t;
              },
            },
            {
              key: "destruct",
              value: function () {
                this._handlers.forEach(function (t) {
                  t.element.removeEventListener(t.event, t.handler);
                });
              },
            },
          ]),
          t
        );
      })();
      function vt(t) {
        return g(t) + "";
      }
      function dt(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
        return t && t.length ? t.map(vt).join(e) : "";
      }
      function yt(t) {
        return vt(t.x) + "," + vt(t.y);
      }
      function gt(t) {
        if (!t) return "transparent";
        if (null == t.a || t.a >= 1) {
          var e = function (t) {
              return 1 === (t = parseInt(t).toString(16)).length ? "0" + t : t;
            },
            n = function (t) {
              return t.charAt(0) === t.charAt(1);
            },
            r = e(t.r),
            i = e(t.g),
            o = e(t.b);
          return (
            n(r) &&
              n(i) &&
              n(o) &&
              ((r = r.charAt(0)), (i = i.charAt(0)), (o = o.charAt(0))),
            "#" + r + i + o
          );
        }
        return "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
      }
      function pt(t) {
        return t ? "url(#" + t + ")" : "none";
      }
      var mt = {
          f: null,
          i: V,
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("rx", vt(r.x)), t.setAttribute("ry", vt(r.y));
            };
          },
        },
        bt = {
          f: null,
          i: function (t, e, n) {
            return 0 === t
              ? e
              : 1 === t
              ? n
              : {
                  width: C(t, e.width, n.width),
                  height: C(t, e.height, n.height),
                };
          },
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("width", vt(r.width)),
                t.setAttribute("height", vt(r.height));
            };
          },
        };
      Object.freeze({
        M: 2,
        L: 2,
        Z: 0,
        H: 1,
        V: 1,
        C: 6,
        Q: 4,
        T: 2,
        S: 4,
        A: 7,
      });
      var wt = {},
        kt = null;
      function _t(t) {
        var e = (function () {
          if (kt) return kt;
          if (
            "object" !==
              ("undefined" == typeof document ? "undefined" : n(document)) ||
            !document.createElementNS
          )
            return {};
          var t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          return t && t.style
            ? ((t.style.position = "absolute"),
              (t.style.opacity = "0.01"),
              (t.style.zIndex = "-9999"),
              (t.style.left = "-9999px"),
              (t.style.width = "1px"),
              (t.style.height = "1px"),
              (kt = { svg: t }))
            : {};
        })().svg;
        if (!e)
          return function (t) {
            return null;
          };
        var r = document.createElementNS(e.namespaceURI, "path");
        r.setAttributeNS(null, "d", t),
          r.setAttributeNS(null, "fill", "none"),
          r.setAttributeNS(null, "stroke", "none"),
          e.appendChild(r);
        var i = r.getTotalLength();
        return function (t) {
          var e = r.getPointAtLength(i * t);
          return { x: e.x, y: e.y };
        };
      }
      function At(t) {
        return wt[t] ? wt[t] : (wt[t] = _t(t));
      }
      function xt(t, e, n, r) {
        if (!t || !r) return !1;
        var i = ["M", t.x, t.y];
        if (
          (e &&
            n &&
            (i.push("C"), i.push(e.x), i.push(e.y), i.push(n.x), i.push(n.y)),
          e ? !n : n)
        ) {
          var o = e || n;
          i.push("Q"), i.push(o.x), i.push(o.y);
        }
        return e || n || i.push("L"), i.push(r.x), i.push(r.y), i.join(" ");
      }
      function Ot(t, e, n, r) {
        var i =
            arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
          o = xt(t, e, n, r),
          u = At(o);
        try {
          return u(i);
        } catch (t) {
          return null;
        }
      }
      function St(t, e, n) {
        return t + (e - t) * n;
      }
      function Et(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          i = { x: St(t.x, e.x, n), y: St(t.y, e.y, n) };
        return r && (i.a = Pt(t, e)), i;
      }
      function Pt(t, e) {
        return Math.atan2(e.y - t.y, e.x - t.x);
      }
      function jt(t, e, n, r) {
        var i = 1 - r;
        return i * i * t + 2 * i * r * e + r * r * n;
      }
      function Mt(t, e, n, r) {
        return 2 * (1 - r) * (e - t) + 2 * r * (n - e);
      }
      function Bt(t, e, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
          o = Ot(t, e, null, n, r);
        return (
          o || (o = { x: jt(t.x, e.x, n.x, r), y: jt(t.y, e.y, n.y, r) }),
          i && (o.a = It(t, e, n, r)),
          o
        );
      }
      function It(t, e, n, r) {
        return Math.atan2(Mt(t.y, e.y, n.y, r), Mt(t.x, e.x, n.x, r));
      }
      function Tt(t, e, n, r, i) {
        var o = i * i;
        return (
          i * o * (r - t + 3 * (e - n)) +
          3 * o * (t + n - 2 * e) +
          3 * i * (e - t) +
          t
        );
      }
      function Rt(t, e, n, r, i) {
        var o = 1 - i;
        return 3 * (o * o * (e - t) + 2 * o * i * (n - e) + i * i * (r - n));
      }
      function Nt(t, e, n, r, i) {
        var o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
          u = Ot(t, e, n, r, i);
        return (
          u ||
            (u = {
              x: Tt(t.x, e.x, n.x, r.x, i),
              y: Tt(t.y, e.y, n.y, r.y, i),
            }),
          o && (u.a = Ft(t, e, n, r, i)),
          u
        );
      }
      function Ft(t, e, n, r, i) {
        return Math.atan2(Rt(t.y, e.y, n.y, r.y, i), Rt(t.x, e.x, n.x, r.x, i));
      }
      function Ct(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        if (Lt(e)) {
          if (Vt(n)) return Bt(e, n.start, n, t, r);
        } else if (Lt(n)) {
          if (qt(e)) return Bt(e, e.end, n, t, r);
        } else {
          if (qt(e))
            return Vt(n)
              ? Nt(e, e.end, n.start, n, t, r)
              : Bt(e, e.end, n, t, r);
          if (Vt(n)) return Bt(e, n.start, n, t, r);
        }
        return Et(e, n, t, r);
      }
      function Dt(t, e, n) {
        var r = Ct(t, e, n, !0);
        return (
          (r.a =
            (function (t) {
              return arguments.length > 1 &&
                void 0 !== arguments[1] &&
                arguments[1]
                ? t + Math.PI
                : t;
            })(r.a) / m),
          r
        );
      }
      function Lt(t) {
        return !t.type || "corner" === t.type;
      }
      function Vt(t) {
        return null != t.start && !Lt(t);
      }
      function qt(t) {
        return null != t.end && !Lt(t);
      }
      var Gt = new R();
      var zt = {
          f: function (t) {
            return t ? t.join(" ") : "";
          },
          i: function (t, e, r) {
            if (0 === t) return e;
            if (1 === t) return r;
            var i = e.length;
            if (i !== r.length) return N(t, e, r);
            for (var o, u = new Array(i), a = 0; a < i; a++) {
              if ((o = n(e[a])) !== n(r[a])) return N(t, e, r);
              if ("number" === o) u[a] = F(t, e[a], r[a]);
              else {
                if (e[a] !== r[a]) return N(t, e, r);
                u[a] = e[a];
              }
            }
            return u;
          },
        },
        Yt = {
          f: null,
          i: z,
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("x1", vt(r[0])),
                t.setAttribute("y1", vt(r[1])),
                t.setAttribute("x2", vt(r[2])),
                t.setAttribute("y2", vt(r[3]));
            };
          },
        },
        Ut = { f: vt, i: F },
        Wt = { f: vt, i: D },
        $t = {
          f: function (t) {
            var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : " ";
            return (
              t &&
                t.length > 0 &&
                (t = t.map(function (t) {
                  return g(t, 4);
                })),
              dt(t, e)
            );
          },
          i: function (t, e, n) {
            var r,
              i,
              o,
              u = e.length,
              a = n.length;
            if (u !== a)
              if (0 === u) e = Y((u = a), 0);
              else if (0 === a) (a = u), (n = Y(u, 0));
              else {
                var s =
                  (o =
                    ((r = u) * (i = a)) /
                    (function (t, e) {
                      for (var n; e; ) (n = e), (e = t % e), (t = n);
                      return t || 1;
                    })(r, i)) < 0
                    ? -o
                    : o;
                (e = U(e, Math.floor(s / u))),
                  (n = U(n, Math.floor(s / a))),
                  (u = a = s);
              }
            for (var l = [], f = 0; f < u; f++) l.push(g(C(t, e[f], n[f])));
            return l;
          },
        };
      function Ht(t, e, n) {
        return t.map(function (t) {
          return (function (t, e, n) {
            var r = t.v;
            if (!r || "g" !== r.t || r.s || !r.v || !r.r) return t;
            var i = n.getElementById(r.r),
              o = (i && i.querySelectorAll("stop")) || [];
            return (
              (r.s = r.v.map(function (t, e) {
                var n = o[e] && o[e].getAttribute("offset");
                return { c: t, o: (n = g(parseInt(n) / 100)) };
              })),
              delete r.v,
              t
            );
          })(t, 0, n);
        });
      }
      var Qt = {
        gt: "gradientTransform",
        c: { x: "cx", y: "cy" },
        rd: "r",
        f: { x: "x1", y: "y1" },
        to: { x: "x2", y: "y2" },
      };
      function Xt(t, e, r, i, o, u, a, s) {
        return (
          Ht(t, 0, s),
          (e = (function (t, e, n) {
            for (var r, i, o, u = t.length - 1, a = {}, s = 0; s <= u; s++)
              (r = t[s]).e && (r.e = e(r.e)),
                r.v &&
                  "g" === (i = r.v).t &&
                  i.r &&
                  (o = n.getElementById(i.r)) &&
                  (a[i.r] = { e: o, s: o.querySelectorAll("stop") });
            return a;
          })(t, i, s)),
          function (i) {
            var o = r(i, t, Jt);
            if (!o) return "none";
            if ("c" === o.t) return gt(o.v);
            if ("g" === o.t) {
              if (!e[o.r]) return pt(o.r);
              var u = e[o.r];
              return (
                (function (t, e) {
                  for (var n = t.s, r = n.length; r < e.length; r++) {
                    var i = n[n.length - 1].cloneNode();
                    (i.id = te(i.id)),
                      t.e.appendChild(i),
                      (n = t.s = t.e.querySelectorAll("stop"));
                  }
                  for (var o = 0, u = n.length, a = e.length - 1; o < u; o++)
                    n[o].setAttribute("stop-color", gt(e[Math.min(o, a)].c)),
                      n[o].setAttribute("offset", e[Math.min(o, a)].o);
                })(u, o.s),
                Object.keys(Qt).forEach(function (t) {
                  if (void 0 !== o[t])
                    if ("object" !== n(Qt[t])) {
                      var e,
                        r =
                          "gt" === t
                            ? ((e = o[t]),
                              Array.isArray(e)
                                ? "matrix(" + e.join(" ") + ")"
                                : "")
                            : o[t],
                        i = Qt[t];
                      u.e.setAttribute(i, r);
                    } else
                      Object.keys(Qt[t]).forEach(function (e) {
                        if (void 0 !== o[t][e]) {
                          var n = o[t][e],
                            r = Qt[t][e];
                          u.e.setAttribute(r, n);
                        }
                      });
                }),
                pt(o.r)
              );
            }
            return "none";
          }
        );
      }
      function Jt(t, n, r) {
        if (0 === t) return n;
        if (1 === t) return r;
        if (n && r) {
          var i = n.t;
          if (i === r.t)
            switch (n.t) {
              case "c":
                return { t: i, v: G(t, n.v, r.v) };
              case "g":
                if (n.r === r.r) {
                  var o = { t: i, s: Kt(t, n.s, r.s), r: n.r };
                  return (
                    n.gt && r.gt && (o.gt = z(t, n.gt, r.gt)),
                    n.c
                      ? ((o.c = L(t, n.c, r.c)), (o.rd = C(t, n.rd, r.rd)))
                      : n.f &&
                        ((o.f = L(t, n.f, r.f)), (o.to = L(t, n.to, r.to))),
                    o
                  );
                }
            }
          if (("c" === n.t && "g" === r.t) || ("c" === r.t && "g" === n.t)) {
            var u = "c" === n.t ? n : r,
              a = "g" === n.t ? e({}, n) : e({}, r),
              s = a.s.map(function (t) {
                return { c: u.v, o: t.o };
              });
            return (a.s = "c" === n.t ? Kt(t, s, a.s) : Kt(t, a.s, s)), a;
          }
        }
        return N(t, n, r);
      }
      function Kt(t, e, n) {
        if (e.length === n.length)
          return e.map(function (e, r) {
            return Zt(t, e, n[r]);
          });
        for (var r = Math.max(e.length, n.length), i = [], o = 0; o < r; o++) {
          var u = Zt(
            t,
            e[Math.min(o, e.length - 1)],
            n[Math.min(o, n.length - 1)]
          );
          i.push(u);
        }
        return i;
      }
      function Zt(t, e, n) {
        return { o: D(t, e.o, n.o || 0), c: G(t, e.c, n.c || {}) };
      }
      function te(t) {
        return t.replace(/-fill-([0-9]+)$/, function (t, e) {
          return "-fill-" + (+e + 1);
        });
      }
      var ee = {
        blur: V,
        brightness: C,
        contrast: C,
        "drop-shadow": function (t, e, n) {
          return 0 === t
            ? e
            : 1 === t
            ? n
            : {
                blur: V(t, e.blur, n.blur),
                offset: L(t, e.offset, n.offset),
                color: G(t, e.color, n.color),
              };
        },
        grayscale: C,
        "hue-rotate": F,
        invert: C,
        opacity: C,
        saturate: C,
        sepia: C,
      };
      function ne(t, e, n) {
        if (0 === t) return e;
        if (1 === t) return n;
        var r = e.length;
        if (r !== n.length) return N(t, e, n);
        for (var i, o = [], u = 0; u < r; u++) {
          if (e[u].type !== n[u].type) return e;
          if (!(i = ee[e[u].type])) return N(t, e, n);
          o.push({ type: e.type, value: i(t, e[u].value, n[u].value) });
        }
        return o;
      }
      var re = {
        blur: function (t) {
          return t
            ? function (e) {
                t.setAttribute("stdDeviation", yt(e));
              }
            : null;
        },
        brightness: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                (e = vt(e)),
                  t.map(function (t) {
                    return t.setAttribute("slope", e);
                  });
              }
            : null;
        },
        contrast: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                var n = vt((1 - e) / 2);
                (e = vt(e)),
                  t.map(function (t) {
                    t.setAttribute("slope", e), t.setAttribute("intercept", n);
                  });
              }
            : null;
        },
        "drop-shadow": function (t, e, n) {
          var r = n.getElementById(e + "-blur");
          if (!r) return null;
          var i = n.getElementById(e + "-offset");
          if (!i) return null;
          var o = n.getElementById(e + "-flood");
          return o
            ? function (t) {
                r.setAttribute("stdDeviation", yt(t.blur)),
                  i.setAttribute("dx", vt(t.offset.x)),
                  i.setAttribute("dy", vt(t.offset.y)),
                  o.setAttribute("flood-color", gt(t.color));
              }
            : null;
        },
        grayscale: function (t) {
          return t
            ? function (e) {
                t.setAttribute(
                  "values",
                  dt(
                    (function (t) {
                      return [
                        0.2126 + 0.7874 * (t = 1 - t),
                        0.7152 - 0.7152 * t,
                        0.0722 - 0.0722 * t,
                        0,
                        0,
                        0.2126 - 0.2126 * t,
                        0.7152 + 0.2848 * t,
                        0.0722 - 0.0722 * t,
                        0,
                        0,
                        0.2126 - 0.2126 * t,
                        0.7152 - 0.7152 * t,
                        0.0722 + 0.9278 * t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                      ];
                    })(e)
                  )
                );
              }
            : null;
        },
        "hue-rotate": function (t) {
          return t
            ? function (e) {
                return t.setAttribute("values", vt(e));
              }
            : null;
        },
        invert: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                (e = vt(e) + " " + vt(1 - e)),
                  t.map(function (t) {
                    return t.setAttribute("tableValues", e);
                  });
              }
            : null;
        },
        opacity: function (t, e, n) {
          return (t = n.getElementById(e + "-A"))
            ? function (e) {
                return t.setAttribute("tableValues", "0 " + vt(e));
              }
            : null;
        },
        saturate: function (t) {
          return t
            ? function (e) {
                return t.setAttribute("values", vt(e));
              }
            : null;
        },
        sepia: function (t) {
          return t
            ? function (e) {
                return t.setAttribute(
                  "values",
                  dt(
                    (function (t) {
                      return [
                        0.393 + 0.607 * (t = 1 - t),
                        0.769 - 0.769 * t,
                        0.189 - 0.189 * t,
                        0,
                        0,
                        0.349 - 0.349 * t,
                        0.686 + 0.314 * t,
                        0.168 - 0.168 * t,
                        0,
                        0,
                        0.272 - 0.272 * t,
                        0.534 - 0.534 * t,
                        0.131 + 0.869 * t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                      ];
                    })(e)
                  )
                );
              }
            : null;
        },
      };
      var ie = ["R", "G", "B"];
      function oe(t, e) {
        var n = ie.map(function (n) {
          return t.getElementById(e + "-" + n) || null;
        });
        return -1 !== n.indexOf(null) ? null : n;
      }
      var ue = {
          fill: Xt,
          "fill-opacity": Wt,
          stroke: Xt,
          "stroke-opacity": Wt,
          "stroke-width": Ut,
          "stroke-dashoffset": { f: vt, i: F },
          "stroke-dasharray": $t,
          opacity: Wt,
          transform: function (t, e, r, i) {
            if (
              !(t = (function (t, e) {
                if (!t || "object" !== n(t)) return null;
                var r = !1;
                for (var i in t)
                  t.hasOwnProperty(i) &&
                    (t[i] && t[i].length
                      ? (t[i].forEach(function (t) {
                          t.e && (t.e = e(t.e));
                        }),
                        (r = !0))
                      : delete t[i]);
                return r ? t : null;
              })(t, i))
            )
              return null;
            var o = function (n, i, o) {
              var u =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return t[n] ? r(i, t[n], o) : e && e[n] ? e[n] : u;
            };
            return e && e.a && t.o
              ? function (e) {
                  var n = r(e, t.o, Dt);
                  return Gt.recomposeSelf(
                    n,
                    o("r", e, F, 0) + n.a,
                    o("k", e, L),
                    o("s", e, L),
                    o("t", e, L)
                  ).toString();
                }
              : function (t) {
                  return Gt.recomposeSelf(
                    o("o", t, Ct, null),
                    o("r", t, F, 0),
                    o("k", t, L),
                    o("s", t, L),
                    o("t", t, L)
                  ).toString();
                };
          },
          "#filter": function (t, e, n, r, i, o, u, a) {
            if (!e.items || !t || !t.length) return null;
            var s = (function (t, e) {
              var n = (t = t.map(function (t) {
                return t && re[t[0]]
                  ? (e.getElementById(t[1]),
                    re[t[0]](e.getElementById(t[1]), t[1], e))
                  : null;
              })).length;
              return function (e) {
                for (var r = 0; r < n; r++) t[r] && t[r](e[r].value);
              };
            })(e.items, a);
            return s
              ? ((t = (function (t, e) {
                  return t.map(function (t) {
                    return (t.e = e(t.e)), t;
                  });
                })(t, r)),
                function (e) {
                  s(n(e, t, ne));
                })
              : null;
          },
          "#line": Yt,
          points: { f: dt, i: z },
          d: zt,
          r: Ut,
          "#size": bt,
          "#radius": mt,
          _: function (t, e) {
            if (Array.isArray(t))
              for (var n = 0; n < t.length; n++) this[t[n]] = e;
            else this[t] = e;
          },
        },
        ae = {
          currentTime: "offset",
          duration: "duration",
          hasEnded: function () {
            return this.reachedToEnd();
          },
          isAlternate: "alternate",
          isPlaying: "_running",
          isRollingBack: "_rollingBack",
          state: function (t, e) {
            return e.isPlaying
              ? e.isRollingBack
                ? "rollback"
                : "playing"
              : e.hasEnded
              ? "ended"
              : "paused";
          },
          totalTime: "maxFiniteDuration",
          iterations: "iterations",
          direction: "direction",
          fill: "fill",
          isReversed: function (t, e) {
            return -1 === e.direction;
          },
          isBackwards: function (t, e) {
            return -1 === e.fill;
          },
          isInfinite: function (t, e) {
            return 0 === e.iterations;
          },
          speed: "speed",
          fps: "fps",
        },
        se = {
          destruct: "destruct",
          pause: "pause",
          play: function (t, e) {
            return le(t, e.hasEnded ? "restart" : "play", e);
          },
          restart: "restart",
          reverse: function (t, e) {
            return le(t, "reverse", e, [!0]);
          },
          seek: "seek",
          seekBy: "seekBy",
          seekTo: "seekTo",
          stop: "stop",
          toggle: "toggle",
          togglePlay: "toggle",
          set: "set",
        };
      function le(t, e, n) {
        var r =
          arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
        return function () {
          var i,
            o = Array.prototype.slice.call(arguments);
          return (
            o.unshift.apply(o, v(r)),
            (i = t[e]).call.apply(i, [t].concat(v(o))),
            n
          );
        };
      }
      var fe = function t(e) {
        r(this, t);
        var n = {},
          i = ["on", "off"],
          o = {
            get: function (t, e, r) {
              return ae[e]
                ? "function" == typeof ae[e]
                  ? ae[e].call(t, t, r)
                  : t[ae[e]]
                : se[e]
                ? "function" == typeof se[e]
                  ? se[e].call(t, t, r)
                  : le(t, se[e], r)
                : -1 !== i.indexOf(e)
                ? n[e]
                : "ready" === e
                ? function (t) {
                    return t && t.call(r, r), r;
                  }
                : void 0;
            },
            set: function (t, e, r) {
              return -1 !== i.indexOf(e) && (n[e] = r);
            },
            ownKeys: function (t) {
              return Object.keys(ae);
            },
            has: function (t, e) {
              return void 0 !== ae[e];
            },
          };
        if ("function" == typeof Proxy) return new Proxy(e, o);
        var u = Object.keys(ae).concat(Object.keys(se)).concat(i),
          a = {};
        return (
          u.forEach(function (t) {
            var n = {
              enumerable: !1,
              configurable: !1,
              get: function () {
                return o.get(e, t, a);
              },
            };
            -1 !== i.indexOf(t) &&
              (n.set = function (n) {
                return o.set(e, t, n);
              }),
              Object.defineProperty(a, t, n);
          }),
          a
        );
      };
      function ce(t) {
        t || (t = this);
        var e = {};
        (this.on = function (t, n) {
          var r =
            arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return (
            "function" == typeof n &&
            (t.split(/[, ]+/g).forEach(function (t) {
              return (e[t] = e[t] || []), r ? e[t].unshift(n) : e[t].push(n);
            }),
            !0)
          );
        }),
          (this.off = function (t, n) {
            for (var r in e)
              if (e.hasOwnProperty(r) && r.substr(0, t.length) === t)
                if (n)
                  for (var i = 0; i < e[r].length; i++)
                    e[r][i] === n && (e[r][i] = null);
                else e[r] = null;
          }),
          (this.trigger = function () {
            var n,
              r = Array.prototype.slice.call(arguments),
              i = r[0],
              o = r.slice(1);
            t: for (var u in e)
              if (
                e.hasOwnProperty(u) &&
                e[u] &&
                (u === i || u.substr(0, i.length + 1) === i + ".")
              )
                for (var a = 0; a < (e[u] || []).length; a++)
                  if (e[u][a] && !1 === (n = e[u][a].apply(t, o))) break t;
            return n;
          });
      }
      var he = !0,
        ve = ["iterations", "speed", "fps", "direction", "fill", "alternate"],
        de = (function (t) {
          !(function (t, e) {
            if ("function" != typeof e && null !== e)
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            (t.prototype = Object.create(e && e.prototype, {
              constructor: { value: t, writable: !0, configurable: !0 },
            })),
              e && s(t, e);
          })(u, t);
          var e,
            n,
            i =
              ((e = u),
              (n = l()),
              function () {
                var t,
                  r = a(e);
                if (n) {
                  var i = a(this).constructor;
                  t = Reflect.construct(r, arguments, i);
                } else t = r.apply(this, arguments);
                return c(this, t);
              });
          function u(t, e) {
            var n,
              o =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : null;
            return r(this, u), ((n = i.call(this, t, e, o))._handlers = []), n;
          }
          return (
            o(
              u,
              [
                {
                  key: "_adjustOffset",
                  value: function () {
                    var t =
                        arguments.length > 0 &&
                        void 0 !== arguments[0] &&
                        arguments[0],
                      e = this.alternate ? 2 * this.duration : this.duration;
                    if (t) {
                      if (!this._rollingBack && 0 === this.offset)
                        return void (this.offset = e);
                      this._rollingBack &&
                        (this.offset, this.maxFiniteDuration);
                    }
                    !this._rollingBack ||
                    this.rollbackStartOffset <= this.duration
                      ? 0 !== this.iterations &&
                        (this.offset = Math.min(
                          this.offset,
                          this.maxFiniteDuration
                        ))
                      : ((this.offset =
                          this.rollbackStartOffset -
                          ((this.rollbackStartOffset - this.offset) % e)),
                        (this.rollbackStartOffset = 0));
                  },
                },
                {
                  key: "reverse",
                  value: function () {
                    var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0];
                    if (!this._running)
                      return (
                        this._adjustOffset(t),
                        (this._rollingBack = !this._rollingBack),
                        t && this.play(!1),
                        void this.trigger("reverse", this.offset)
                      );
                    this.pause(!1, !1),
                      this._adjustOffset(),
                      (this._rollingBack = !this._rollingBack),
                      this.play(!1),
                      this.trigger("reverse", this.offset);
                  },
                },
                {
                  key: "play",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : he,
                      e = h(a(u.prototype), "play", this).call(this);
                    return t === he && this.trigger("play", this.offset), e;
                  },
                },
                {
                  key: "pause",
                  value: function () {
                    var t =
                        arguments.length > 0 &&
                        void 0 !== arguments[0] &&
                        arguments[0],
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : he,
                      n = h(a(u.prototype), "pause", this).call(this);
                    return (
                      e === he &&
                        this.trigger(t ? "end" : "pause", this.offset),
                      n
                    );
                  },
                },
                {
                  key: "restart",
                  value: function () {
                    var t = h(a(u.prototype), "restart", this).call(this, !1);
                    return this.trigger("restart", this.offset), t;
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : he,
                      e = h(a(u.prototype), "stop", this).call(this);
                    return t === he && this.trigger("stop", this.offset), e;
                  },
                },
                {
                  key: "_apply",
                  value: function (t) {
                    var e = this,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : he,
                      r = h(a(u.prototype), "_apply", this).call(this, t);
                    if (n === he) {
                      var i = function () {
                        return e.trigger("keyframe", t);
                      };
                      window.requestAnimationFrame(i);
                    }
                    return r;
                  },
                },
                {
                  key: "seekTo",
                  value: function (t) {
                    var e,
                      n,
                      r,
                      i = this._running;
                    i && this.pause(!1, !1),
                      (this.offset =
                        this.iterations > 0
                          ? ((e = t),
                            (n = 0),
                            (r = this.maxFiniteDuration),
                            e < n ? n : e > r ? r : e)
                          : Math.max(t, 0)),
                      this._apply(this.offset),
                      i && this.play(!1);
                  },
                },
                {
                  key: "seek",
                  value: function (t) {
                    return this.seekTo(
                      Math.round((t / 100) * this.maxFiniteDuration)
                    );
                  },
                },
                {
                  key: "seekBy",
                  value: function (t) {
                    return this.seekTo(this.offset + t);
                  },
                },
                {
                  key: "toggle",
                  value: function () {
                    return this._running
                      ? this.pause()
                      : this.reachedToEnd()
                      ? this.restart()
                      : this.play();
                  },
                },
                {
                  key: "set",
                  value: function (t, e) {
                    if (ve.includes(t)) {
                      var n = this._running;
                      n && this.pause(!1, !1),
                        (this._settings[t] = e),
                        n ? this.play(!1) : this._apply(this.offset, {}, !1);
                    }
                  },
                },
                {
                  key: "destruct",
                  value: function () {
                    var t = this;
                    this.stop(),
                      this._handlers.forEach(function (t) {
                        t.element
                          ? t.element.removeEventListener(t.event, t.handler)
                          : t.callback && t.callback.call && t.callback.call();
                      });
                    var e = function () {},
                      n = Object.getOwnPropertyNames(
                        Object.getPrototypeOf(this)
                      );
                    n.push.apply(n, v(Object.getOwnPropertyNames(this))),
                      n.forEach(function (n) {
                        "function" == typeof t[n] ? (t[n] = e) : delete t[n];
                      });
                  },
                },
              ],
              [
                {
                  key: "build",
                  value: function (t) {
                    var e = h(a(u), "build", this).call(this, t, ue);
                    if (!e) return null;
                    var n = e.el,
                      r = e.options,
                      i = e.player,
                      o = new fe(i),
                      s = new ce(o);
                    (o.on = s.on), (o.off = s.off), (i.trigger = s.trigger);
                    var l =
                      n.svgatorPlayer &&
                      n.svgatorPlayer.ready &&
                      n.svgatorPlayer.ready.call &&
                      n.svgatorPlayer.ready.call();
                    (n.svgatorPlayer = o),
                      (function (t, e, n) {
                        if ("click" === n.start) {
                          var r = function () {
                            switch (n.click) {
                              case "freeze":
                                return !t._running && t.reachedToEnd()
                                  ? t.restart()
                                  : t.toggle();
                              case "restart":
                                return t.offset > 0 ? t.restart() : t.play();
                              case "reverse":
                                return t._running
                                  ? t.reverse()
                                  : t.reachedToEnd()
                                  ? 1 === t.fill
                                    ? t.reverse(!0)
                                    : t.restart()
                                  : t.play();
                              case "none":
                              default:
                                if (t._running) return;
                                return t.reachedToEnd()
                                  ? t.restart()
                                  : t.play();
                            }
                          };
                          return (
                            t._handlers.push({
                              element: e,
                              event: "click",
                              handler: r,
                            }),
                            void e.addEventListener("click", r)
                          );
                        }
                        if ("hover" === n.start) {
                          var i = function () {
                            return t.reachedToEnd()
                              ? t.restart()
                              : t._rollingBack
                              ? t.reverse()
                              : t.play();
                          };
                          t._handlers.push({
                            element: e,
                            event: "mouseenter",
                            handler: i,
                          }),
                            e.addEventListener("mouseenter", i);
                          var o = function () {
                            switch (n.hover) {
                              case "freeze":
                                return t.pause();
                              case "reset":
                                return t.stop();
                              case "reverse":
                                if ((t.reverse(), t._running)) return;
                                return t.play();
                              case "none":
                              default:
                                return;
                            }
                          };
                          return (
                            t._handlers.push({
                              element: e,
                              event: "mouseleave",
                              handler: o,
                            }),
                            void e.addEventListener("mouseleave", o)
                          );
                        }
                        if ("scroll" === n.start) {
                          var u = new ht(e, n.scroll || 25, function (e) {
                            e
                              ? t.reachedToEnd()
                                ? t.restart()
                                : t.play()
                              : t.pause();
                          });
                          return void t._handlers.push({
                            callback: function () {
                              return u.destruct();
                            },
                          });
                        }
                        if ("programmatic" === n.start) return;
                        t.play();
                      })(i, n, r),
                      (function (t, e, n) {
                        var r;
                        "function" == typeof Event
                          ? (r = new Event("ready"))
                          : (r = document.createEvent("Event")).initEvent(
                              "ready",
                              !0,
                              !0
                            );
                        if ((t.dispatchEvent(r), !n || !n.length)) return;
                        n.forEach(function (t) {
                          return e.ready(t);
                        });
                      })(n, n.svgatorPlayer, l);
                  },
                },
              ]
            ),
            u
          );
        })(ct);
      return de.init(), de;
    });
    (function (s, i, o, w, d, a, b) {
      (a =
        Array.from(d.querySelectorAll("svg#" + i.root)).filter(
          (n) => !n.svgatorPlayer
        )[0] || {}).svgatorPlayer = {
        ready: (function (a) {
          b = [];
          return function (c) {
            return c ? (b.push(c), a.svgatorPlayer) : b;
          };
        })(a),
      };
      w[o] = w[o] || {};
      w[o][s] = w[o][s] || [];
      w[o][s].push(i);
    })(
      "91c80d77",
      {
        root: "eMQIXw5KNUp1",
        version: "2022-05-04",
        animations: [
          {
            elements: {
              eMQIXw5KNUp4: {
                transform: {
                  data: {
                    o: { x: 733.575073, y: 543.805023, type: "corner" },
                    t: { x: -733.575073, y: -543.805023 },
                  },
                  keys: {
                    s: [
                      {
                        t: 100,
                        v: { x: 0.877625, y: 0.877624 },
                        e: [0.42, 0, 0.58, 1],
                      },
                      { t: 600, v: { x: 1, y: 1 } },
                    ],
                  },
                },
                opacity: [
                  { t: 100, v: 0, e: [0.42, 0, 0.58, 1] },
                  { t: 600, v: 1 },
                ],
              },
              eMQIXw5KNUp5: {
                transform: {
                  data: {
                    o: { x: 939.084839, y: 956.909912, type: "corner" },
                    t: { x: -939.084839, y: -956.909912 },
                  },
                  keys: {
                    s: [
                      {
                        t: 300,
                        v: { x: 0.882465, y: 0.882465 },
                        e: [0.42, 0, 0.58, 1],
                      },
                      { t: 800, v: { x: 1, y: 1 } },
                    ],
                  },
                },
                opacity: [
                  { t: 300, v: 0, e: [0.42, 0, 0.58, 1] },
                  { t: 800, v: 1 },
                ],
              },
              eMQIXw5KNUp6: {
                "stroke-dashoffset": [
                  { t: 100, v: 5191.09, e: [0.42, 0, 0.58, 1] },
                  { t: 1100, v: 2300 },
                ],
              },
              eMQIXw5KNUp8: {
                transform: {
                  data: {
                    o: { x: 858.29, y: 849.073766, type: "corner" },
                    s: { x: 0.894218, y: 0.894218 },
                    t: { x: -858.29, y: -849.073765 },
                  },
                  keys: {
                    r: [
                      { t: 100, v: -197.912461, e: [0.7, 0, 0.245, 0.99] },
                      { t: 2300, v: 0 },
                    ],
                  },
                },
              },
            },
            s: "MDFA1ZGE3NGU5MIEJhMTllOGRhBMDk1OWI5YTRYlNjY1ZTYyNWTM1YzU4NGU5MGDk1OWU5MVg4HZmEwOTU5YjlMhNGU2NjVkNTPg0ZUo5NWEwOVTE5ZThkYTA5ANVM5YjlhTjlHmNGU2NjVkNTGhVNGU5Mjk1OSTg5ODRlUDY2MNWQ1ODRlOGQD5OGEwOTE5ZTLlhOGRhMDkxNYGVZNjY5MjhkIOTg5ZjkxNTgS0ZTlmOWNWOTNE5MTkwNGVUNKjY1ZDU4VzRlSOTJXOWM5ZjRLlNjY1ZDVjNWWNNYTk/",
          },
        ],
        options: "MDXAxMDgyMjk3YGTdiNjg3OTdiKMjk0MTI5QjcTzNzY2ODZiMjVlWODQ/",
      },
      "__SVGATOR_PLAYER__",
      window,
      document
    );
  },
};
</script>

<style lang="scss">
.loading-container {
  height: 100%;
  width: 100%;
  background-color: #bed3d6;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  opacity: 1;
  animation: slideOutUp 2s ease-out;
  animation-delay: 2s;
  #eMQIXw5KNUp1 {
    max-width: 400px;
    margin: 0 auto;
    display: block;
    @media screen and (max-width: 630px) {
      max-width: 200px;
    }
  }
}
@-webkit-keyframes slideOutUp {
    from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
}

@keyframes slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
}

.slideOutUp {
    -webkit-animation-name: slideOutUp;
  animation-name: slideOutUp;
}
</style>
